import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { translateFn } from '../../../../utils/translator.helper';
import { GzRepairAgentWebComponent } from './component/GzRepairAgentWebComponent';
import { NetworkPopUpFooterContentWebComponent } from '../NetworkPopUpFooterContentWebComponent';
import { CreateTaskRequest } from '../../types';

export class RepairAgentPopUp extends NetworkBasePopUp<GzRepairAgentWebComponent> {
  protected title = translateFn('Repair agent');
  protected extraDialogConfigs = {
    isWindow: false,
  };
  protected transformToTaskTarget = true;

  protected customSetup() {
    this.popUpFooterContent = new NetworkPopUpFooterContentWebComponent();
    this.popUpFooterContent.confirmButtonDisabled = true;
    this.popUpContent = new GzRepairAgentWebComponent();
  }

  protected handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    const payload: CreateTaskRequest = {
      settings: {
        targets: this.data.targets || [],
        taskName: this.getFormattedTaskName(),
        type: Constants.Tasks.Endpoints.TASK_TYPE_REPAIR_ENDPOINT_PARENT,
      },
    };

    return this.createTask(payload);
  }

  /**
   * Returns task name as "Repair agent YYYY-MM-DD"
   * @private
   */
  private getFormattedTaskName(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');

    return `${this.title} ${year}-${month}-${day}`;
  }
}
